import { render } from "./AlbertaFooter.vue?vue&type=template&id=293ab678"
const script = {}
script.render = render

export default script